import React, { useEffect, useState, useContext, useRef, useCallback } from "react";
import {
  Listprostock,
  Documentexp,
  getDashboardReport,
  getMostReportData,
  updateDocumentsTable,
  getNotification,
  getRawMaterials,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import { DocumentViewerModal } from "../../Common/Functions";
import { shop_id, yesterdayDate, currentDate } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import PieChart from "../../Common/charts/PieChart";
import ExpiryAlert from "./common/ExpiryAlert";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [stockAlerts, setStockAlerts] = useState([]);

  const convertQtyToKg = (qty, weight, unit) => {
    const q = parseFloat(qty || 0);
    const w = parseFloat(weight || 0);
    if (!unit) return q;
    const normalized = unit.toLowerCase().trim();

    let weightInKg = 0;
    switch (normalized) {
      case "kg":
      case "kilogram":
      case "kilograms":
        weightInKg = w;
        break;
      case "mg":
      case "milligram":
      case "milligrams":
        weightInKg = w / 1000000;
        break;
      case "g":
      case "gram":
      case "grams":
      default:
        weightInKg = w / 1000;
        break;
    }
    return parseFloat((q * weightInKg).toFixed(2));
  };
  const [document, setDocument] = useState([]);
  const [reportData, setReportData] = useState();
  const [documentModal, setDocumentModal] = useState(false);
  const [DocumentUrl, setDocumentUrl] = useState("");
  const [mostData, setMostData] = useState();
  const { showLoader, hideLoader, UserItem } = useContext(WarehouseContext);
  const rolePermissions = UserItem?.menu_list ? JSON.parse(UserItem.menu_list) : [];
  const role = UserItem?.role_title?.toLowerCase();
  const isAdminOrSuper = role === "super admin" || role === "admin";
  const hasRoutePermission = (route) => {
    if (isAdminOrSuper) return true;
    if (route === "/e_product_process") {
      return rolePermissions.some(r => r.menu === "/Product_list");
    }
    return rolePermissions.some(r => r.menu === route);
  };

  const navigate = useNavigate();
  const [selectedDocumentTable, setSelectedDocumentTable] = useState(null);
  const [formData, setFormData] = useState({ expiry_date: "", document: null });
  const [showModal, setShowModal] = useState(false);
  const fileInputRef = useRef(null);
  const [isFileSelected, setIsFileSelected] = useState(false);

  const [mostLoyalCustomers, setMostLoyalCustomers] = useState([]);
  const [mostSellingProduct, setMostSellingProduct] = useState([]);
  const [rawetrial, setRawetrial] = useState([]);
  const [availableRawMaterials, setAvailableRawMaterials] = useState(0);

  useEffect(() => {
    fetchdata();
    fetchdoc();
    fetchDashboardReport();
    fetchMostReportData();
    fetchNotification();
    fetchAvailableRawMaterials();
  }, []);

  const fetchdata = useCallback(async () => {
    try {
      const response = await Listprostock();
      const data = response?.data?.data;

      setStockAlerts(Array.isArray(data?.products) ? data.products : []);
      setRawetrial(Array.isArray(data?.raw_materials) ? data.raw_materials : []);

    } catch (error) {
      console.error("Failed to fetch stock data:", error);
      setStockAlerts([]);
      setRawetrial([]);
    }
  }, []);


  // const fetchdata = useCallback(async () => {
  //   try {
  //     const response = await Listprostock();
  //     const data = response?.data;

  //     setStockAlerts(Array.isArray(data?.products) ? data.products : []);
  //     setRawetrial(Array.isArray(data?.raw_materials) ? data.raw_materials : []);
  //   } catch (error) {
  //     console.error("Failed to fetch stock data:", error);
  //     setStockAlerts([]);
  //     setRawetrial([]);
  //   }
  // }, []);


  const handleCancel = () => {
    setShowModal(false);
    setIsFileSelected(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const Handledocumentview = (viewer) => {
    const Url = `http://193.203.162.101:8002/media/${viewer}`;
    setDocumentUrl(Url); // Set the document URL
    setDocumentModal(true); // Open the modal
  };

  const fetchdoc = async () => {
    try {
      const response = await Documentexp();
      if (response.data && response.data.data) {
        setDocument(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchDashboardReport = async () => {
    try {
      const response = await getDashboardReport();
      if (response.data && response.data.data) {
        setReportData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchMostReportData = async () => {
    try {
      // const response = await getMostReportData(shop_id, fromDate, toDate);
      const response = await getMostReportData(shop_id);
      if (response.data) {
        setMostData(response.data);

        var cus = response.data?.most_buying_customers || [];
        const formattedCusData = cus.map((item) => ({
          title: item.customer_name,
          value: item.order_count,
        }));
        var pod = response.data?.most_sold_products || [];
        const formattedPodData = pod.map((item) => ({
          title: item.product_name, // Map product_name to title
          value: item.sold_qty,     // Map sold_qty to value
        }));

        setMostLoyalCustomers(formattedCusData || []);
        setMostSellingProduct(formattedPodData || []);
      }
    } catch (err) {
      console.log("Assets Error", err);
    }
  };

  const handleEditClick = (data) => {
    setSelectedDocumentTable(data);
    setFormData({
      expiry_date: data.expiry_date || "",
      document: data.document || null,
    });

    // Reset file input manually
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    setShowModal(true);
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      setFormData((prevFormData) => ({
        ...prevFormData,
        document: file,
      }));
      setIsFileSelected(true);
    } else {
      setIsFileSelected(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedDocumentTable?.document_id) return;

    const formDataObj = new FormData();
    formDataObj.append("expiry_date", formData.expiry_date);

    if (formData.document) {
      formDataObj.append("file_upload", formData.document);
    } else {
      console.warn("No new file selected!");
    }

    showLoader();
    try {
      await updateDocumentsTable(
        selectedDocumentTable.document_id,
        formDataObj
      );
      toast.success("Documents Table Updated successfully");
      fetchdoc();
      setShowModal(false);
      setIsFileSelected(false);
    } catch (error) {
      toast.error("Failed to update document!");
      console.error("Error updating document:", error);
    } finally {
      hideLoader();
    }
  };

  const [expiryData, setExpiryData] = useState({});

  const fetchNotification = useCallback(async () => {
    try {
      const response = await getNotification(shop_id);

      if (response && response.data) {
        const { document = 0, salary = 0, products = 0, profitloss = 0 } = response.data;
        setExpiryData({ document, salary, products, profitloss });
      }
    } catch (error) {
      console.error("Error fetching alerts:", error);
    }
  }, []);

  const fetchAvailableRawMaterials = async () => {
    try {
      const response = await getRawMaterials();
      if (response.data && response.data.data) {
        const rawList = response.data.data;
        const total = rawList.reduce((sum, item) => {
          // Exclude packaging material (type === "1")
          if (String(item.type) !== "1") {
            const stock = parseFloat(item.remaining_stock || 0);
            const unit = String(item.unit_id || "").toLowerCase().trim();

            // If unit is gram (unit_id === "2" or contains "gram" or "gm")
            if (unit === "2" || unit === "gram" || unit === "grams" || unit === "g" || unit === "gm" || unit === "gms") {
              return sum + (stock / 1000);
            }
            return sum + stock;
          }
          return sum;
        }, 0);
        setAvailableRawMaterials(total);
      }
    } catch (error) {
      console.error("Error fetching raw materials for dashboard:", error);
    }
  };

  const totalStockInKg = stockAlerts.reduce((sum, item) => {
    if (
      item?.remaining !== undefined &&
      item?.remaining !== null &&
      item?.p_weight !== undefined &&
      item?.pbox_unit !== undefined
    ) {
      return sum + convertQtyToKg(item.remaining, item.p_weight, item.pbox_unit);
    }
    return sum;
  }, 0);

  const visibleActionsCount = [
    hasRoutePermission("/purchase"),
    hasRoutePermission("/product_order"),
    hasRoutePermission("/salary_list"),
    hasRoutePermission("/expense")
  ].filter(Boolean).length;

  return (
    <div className="space-y-6 p-6 dashboard-container" style={{ fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <style>{`
        .dashboard-container {
          background-color: #F8F9FA !important;
          min-height: 100vh;
        }
        .dashboard-card {
          background: #ffffff !important;
          border: 1px solid #E2E8F0 !important;
          border-radius: 12px !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.02), 0 1px 2px rgba(0,0,0,0.01) !important;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
          overflow: hidden;
          margin-bottom: 0 !important;
        }
        .dashboard-card:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -4px rgba(0, 0, 0, 0.05) !important;
        }
        .metric-title {
          color: #64748B !important;
          font-size: 0.72rem !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.07em !important;
          margin-bottom: 0.25rem !important;
        }
        .metric-value {
          color: #0F172A !important;
          font-size: 1.65rem !important;
          font-weight: 700 !important;
          letter-spacing: -0.03em !important;
          margin: 0 !important;
        }
        .metric-icon-wrapper {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 44px !important;
          height: 44px !important;
          border-radius: 10px !important;
          font-size: 1.3rem !important;
          transition: all 0.2s ease !important;
        }
        .dashboard-table {
          width: 100% !important;
          border-collapse: collapse !important;
        }
        .dashboard-table th {
          text-align: left !important;
          font-size: 0.75rem !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          color: #475569 !important;
          background-color: #F8FAFC !important;
          border-bottom: 1px solid #E2E8F0 !important;
          padding: 14px 20px !important;
          letter-spacing: 0.05em !important;
        }
        .dashboard-table td {
          text-align: left !important;
          font-size: 0.85rem !important;
          color: #334155 !important;
          border-bottom: 1px solid #F1F5F9 !important;
          padding: 14px 20px !important;
        }
        .dashboard-table tr:hover td {
          background-color: #F8FAFC !important;
        }
        .dashboard-card-header {
          border-bottom: 1px solid #F1F5F9 !important;
          padding: 18px 24px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          background-color: transparent !important;
        }
        .dashboard-card-title {
          font-size: 0.95rem !important;
          font-weight: 700 !important;
          color: #0F172A !important;
          margin: 0 !important;
        }
        .dashboard-table-container {
          height: 40vh;
          overflow-y: auto;
        }
        .dashboard-table-container::-webkit-scrollbar {
          width: 6px;
        }
        .dashboard-table-container::-webkit-scrollbar-track {
          background: #F8FAFC;
        }
        .dashboard-table-container::-webkit-scrollbar-thumb {
          background: #CBD5E1;
          border-radius: 3px;
        }
        .dashboard-table-container::-webkit-scrollbar-thumb:hover {
          background: #94A3B8;
        }
        .dashboard-profit-pill {
          font-size: 0.875rem !important;
          font-weight: 600 !important;
          border-radius: 8px !important;
          padding: 8px 16px !important;
          border: 1px solid rgba(255,255,255,0.1) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02) !important;
        }
        .quick-action-card {
          background: #ffffff !important;
          border: 1px solid #E2E8F0 !important;
          border-radius: 12px !important;
          padding: 1.5rem 1rem !important;
          text-align: center !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .quick-action-card:hover {
          transform: translateY(-2px) !important;
          border-color: #CBD5E1 !important;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -4px rgba(0, 0, 0, 0.05) !important;
          background-color: #FAFAFA !important;
        }
        .quick-action-icon {
          font-size: 1.8rem !important;
          margin-bottom: 0.5rem !important;
        }
        .quick-action-title {
          font-size: 0.9rem !important;
          font-weight: 600 !important;
          color: #334155 !important;
        }
        .quick-actions-container:hover {
          transform: none !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.02), 0 1px 2px rgba(0,0,0,0.01) !important;
        }
      `}</style>

      {/* Expiry alerts */}
      {expiryData && (expiryData.document > 0 || expiryData.salary > 0 || expiryData.products > 0) && (
        <div className="row">
          <ExpiryAlert expiryData={expiryData} />
        </div>
      )}

      {/* Modern Dashboard Header Section */}
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-4 mt-2 gap-3">
        <div>
          <h2 className="fw-bold text-dark mb-1" style={{ fontSize: "1.75rem", letterSpacing: "-0.025em" }}>Dashboard</h2>
          <p className="text-secondary mb-0" style={{ fontSize: "0.875rem" }}>Overview of your business performance</p>
        </div>

        {/* Create Process Button */}
        {hasRoutePermission("/e_product_process") && (
          <div className="d-flex align-items-center">
            {/* <div
              className={`d-flex align-items-center gap-2 dashboard-profit-pill text-white 
                ${expiryData?.profitloss > 0
                  ? 'bg-success bg-gradient'
                  : expiryData?.profitloss < 0
                  ? 'bg-danger bg-gradient'
                  : 'bg-secondary bg-gradient'}`} */}

            <button
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 fw-semibold shadow-sm"
              onClick={() => navigate("/e_product_process", { state: { openCreateModal: true } })}
              style={{ borderRadius: "8px" }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Create Process
            </button>
            {/* <i
                className={`bi fs-5 
                  ${expiryData?.profitloss > 0
                    ? 'bi-arrow-up-right-circle-fill'
                    : expiryData?.profitloss < 0
                    ? 'bi-arrow-down-right-circle-fill'
                    : 'bi-dash-circle-fill'}`}
              ></i>
              <span>
                Today's Profit: ₹ {expiryData?.profitloss ?? 0}
              </span>
            </div> */}
          </div>
        )}
      </div>
      {/* Quick Actions Section */}
      {visibleActionsCount > 0 && (
        <div className="dashboard-card quick-actions-container p-4 mb-4">
          <h5 className="fw-bold text-dark mb-4" style={{ fontSize: "1.05rem" }}>Quick Actions</h5>
          <div className="row g-3">
            {hasRoutePermission("/purchase") && (
              <div className="col-12 col-md-6 col-lg-3">
                <div className="quick-action-card" onClick={() => navigate("/purchase")}>
                  <div className="quick-action-icon text-primary">
                    <i className="bx bx-receipt" />
                  </div>
                  <span className="quick-action-title">RM Purchase</span>
                </div>
              </div>
            )}
            {hasRoutePermission("/product_order") && (
              <div className="col-12 col-md-6 col-lg-3">
                <div className="quick-action-card" onClick={() => navigate("/product_order")}>
                  <div className="quick-action-icon text-success">
                    <i className="bx bx-cart" />
                  </div>
                  <span className="quick-action-title">Create Sale</span>
                </div>
              </div>
            )}
            {hasRoutePermission("/salary_list") && (
              <div className="col-12 col-md-6 col-lg-3">
                <div className="quick-action-card" onClick={() => navigate("/salary_list")}>
                  <div className="quick-action-icon text-warning">
                    <i className="bx bx-wallet" />
                  </div>
                  <span className="quick-action-title">Salaries</span>
                </div>
              </div>
            )}
            {hasRoutePermission("/expense") && (
              <div className="col-12 col-md-6 col-lg-3">
                <div className="quick-action-card" onClick={() => navigate("/expense")}>
                  <div className="quick-action-icon text-danger">
                    <i className="bx bx-credit-card" />
                  </div>
                  <span className="quick-action-title">Record Expense</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Main Metric Cards Grid (6 items) */}
      <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4 mb-4">
        {/* Card 1: Total Orders */}
        <div className="col">
          <div className="dashboard-card p-4">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <p className="metric-title">Total Orders</p>
                <h3 className="metric-value">{reportData?.total_orders ?? 0}</h3>
              </div>
              <div className="metric-icon-wrapper" style={{ backgroundColor: '#EFF6FF', color: '#3B82F6' }}>
                <i className="bx bx-cart-alt" />
              </div>
            </div>
            <div className="mt-3 text-muted" style={{ fontSize: "0.75rem" }}>
              <span className="text-muted">Total orders placed</span>
            </div>
          </div>
        </div>

        {/* Card 2: Total Revenue */}
        <div className="col">
          <div className="dashboard-card p-4">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <p className="metric-title">Total Revenue</p>
                <h3 className="metric-value">₹ {Math.round(reportData?.total_revenue || 0).toLocaleString()}</h3>
              </div>
              <div className="metric-icon-wrapper" style={{ backgroundColor: '#ECFDF5', color: '#10B981' }}>
                <i className="bi bi-cash" />
              </div>
            </div>
            <div className="mt-3 text-muted" style={{ fontSize: "0.75rem" }}>
              <span className="text-muted">Total sales revenue</span>
            </div>
          </div>
        </div>

        {/* Card 3: Available End Products */}
        <div className="col">
          <div className="dashboard-card p-4">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <p className="metric-title">Available End Products</p>
                {/* <h3 className="metric-value">{reportData?.total_stocks ?? 0}</h3> */}
                <h3 className="metric-value">{totalStockInKg.toFixed(2)} kg</h3>
              </div>
              <div className="metric-icon-wrapper" style={{ backgroundColor: '#EEF2FF', color: '#6366F1' }}>
                <i className="bx bx-group" />
              </div>
            </div>
            <div className="mt-3 text-muted" style={{ fontSize: "0.75rem" }}>
              <span className="text-muted">Currently active in stock</span>
            </div>
          </div>
        </div>

        {/* Card 4: Sold Items */}
        <div className="col">
          <div className="dashboard-card p-4">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <p className="metric-title">Sold Items</p>
                <h3 className="metric-value">{reportData?.sold_items ?? 0}</h3>
              </div>
              <div className="metric-icon-wrapper" style={{ backgroundColor: '#FFFBEB', color: '#F59E0B' }}>
                <i className="bx bx-beer" />
              </div>
            </div>
            <div className="mt-3 text-muted" style={{ fontSize: "0.75rem" }}>
              <span className="text-muted">Total quantity sold</span>
            </div>
          </div>
        </div>

        {/* Card 5: Total Product */}
        {/* <div className="col">
          <div className="dashboard-card p-4">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <p className="metric-title">Total Product</p>
                <h3 className="metric-value">{reportData?.total_products ?? 0}</h3>
              </div>
              <div className="metric-icon-wrapper" style={{ backgroundColor: '#F5F3FF', color: '#8B5CF6' }}>
                <i className="bx bx-camera-movie" />
              </div>
            </div>
            <div className="mt-3 text-muted" style={{ fontSize: "0.75rem" }}>
              <span className="text-muted">Total registered products</span>
            </div>
          </div>
        </div> */}

        {/* Card 5: Available Raw Materials */}
        <div className="col">
          <div className="dashboard-card p-4">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <p className="metric-title">Available Raw Materials</p>
                <h3 className="metric-value">{availableRawMaterials.toFixed(2)} kg</h3>
              </div>
              <div className="metric-icon-wrapper" style={{ backgroundColor: '#F5F3FF', color: '#8B5CF6' }}>
                <i className="bx bx-layer" />
              </div>
            </div>
            <div className="mt-3 text-muted" style={{ fontSize: "0.75rem" }}>
              <span className="text-muted">Excluding packaging materials</span>
            </div>
          </div>
        </div>

        {/* Card 6: Total Returns */}
        <div className="col">
          <div className="dashboard-card p-4">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <p className="metric-title">Total Returns</p>
                <h3 className="metric-value">{reportData?.total_returns ?? 0}</h3>
              </div>
              <div className="metric-icon-wrapper" style={{ backgroundColor: '#FFF1F2', color: '#F43F5E' }}>
                <i className="bx bx-refresh" />
              </div>
            </div>
            <div className="mt-3 text-muted" style={{ fontSize: "0.75rem" }}>
              <span className="text-muted">Total returned items</span>
            </div>
          </div>
        </div>
      </div>

      {/* Apex Charts Section */}
      <div className="row g-4 mb-4">
        {/* Most Loyal Customers */}
        <div className="col-md-6">
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h6 className="dashboard-card-title">Most Loyal Customers</h6>
            </div>
            {mostLoyalCustomers && mostLoyalCustomers.length > 0 ? (
              <div className="card-body p-4">
                <PieChart data={mostLoyalCustomers} />
              </div>
            ) : (
              <div className="card-body p-4 d-flex align-items-center justify-content-center" style={{ height: "350px" }}>
                <div className="text-center text-muted">
                  <i className="bi bi-people fs-1 d-block mb-2 text-secondary opacity-50"></i>
                  <p className="mb-0 fw-semibold">No customer data available</p>
                  <span className="text-xs" style={{ fontSize: "0.75rem" }}>Charts will appear once orders are placed</span>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Most Selling Products */}
        <div className="col-md-6">
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h6 className="dashboard-card-title">Most Selling Product</h6>
            </div>
            {mostSellingProduct && mostSellingProduct.length > 0 ? (
              <div className="card-body p-4">
                <PieChart type="polarArea" data={mostSellingProduct} />
              </div>
            ) : (
              <div className="card-body p-4 d-flex align-items-center justify-content-center" style={{ height: "350px" }}>
                <div className="text-center text-muted">
                  <i className="bi bi-box-seam fs-1 d-block mb-2 text-secondary opacity-50"></i>
                  <p className="mb-0 fw-semibold">No selling products data available</p>
                  <span className="text-xs" style={{ fontSize: "0.75rem" }}>Charts will appear once products are sold</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Stock Alerts Tables */}
      <div className="row g-4 mb-4">
        {/* Raw Material Stock Alert */}
        <div className="col-md-6">
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h6 className="dashboard-card-title">Raw Material Stock Alert</h6>
            </div>
            <div className="card-body p-0">
              <div className="dashboard-table-container">
                <table className="dashboard-table">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>S.No</th>
                      <th>Product</th>
                      <th style={{ width: "120px" }}>Qty</th>
                      <th style={{ width: "120px" }}>Reorder</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rawetrial.length > 0 ? (
                      rawetrial.map((item, index) => (
                        <tr key={index}>
                          <td className="text-secondary">{index + 1}</td>
                          <td className="fw-semibold text-dark">{item?.name}</td>
                          <td>
                            {/* Fix floating decimal precision overflows */}
                            <span className="badge bg-light text-dark px-2.5 py-1.5" style={{ fontSize: "0.825rem", borderRadius: "6px", border: "1px solid #E2E8F0" }}>
                              {item?.remaining !== undefined && item?.remaining !== null
                                ? parseFloat(parseFloat(item.remaining).toFixed(2))
                                : 0}
                            </span>
                          </td>
                          <td>
                            <span className="badge bg-danger bg-opacity-10 text-danger px-2.5 py-1.5 fw-bold" style={{ fontSize: "0.825rem", borderRadius: "6px" }}>
                              {item?.reorder_point}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center text-muted py-5">
                          No stock alerts found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Product Stock Alert */}
        <div className="col-md-6">
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <h6 className="dashboard-card-title">Product Stock Alert</h6>
            </div>
            <div className="card-body p-0">
              <div className="dashboard-table-container">
                <table className="dashboard-table">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>S.No</th>
                      <th>Name</th>
                      <th style={{ width: "120px" }}>Qty</th>
                      <th style={{ width: "120px" }}>Reorder</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stockAlerts.length > 0 ? (
                      stockAlerts.map((data, index) => (
                        <tr key={index}>
                          <td className="text-secondary">{index + 1}</td>
                          <td className="fw-semibold text-dark">
                            {data?.product_name}{" ("}
                            {data?.pbox_code === "FREE SIZE / LOSE QTY" || data?.p_code === "FREE_SIZE"
                              ? "Lose Packs"
                              : `${data?.p_weight || ''}${data?.pbox_unit || ''}`}
                            {")"}
                          </td>
                          <td>
                            {/* Fix floating decimal precision overflows */}
                            <span className="badge bg-light text-dark px-2.5 py-1.5" style={{ fontSize: "0.825rem", borderRadius: "6px", border: "1px solid #E2E8F0" }}>
                              {/* {data?.remaining !== undefined && data?.remaining !== null
                                ? parseFloat(parseFloat(data.remaining).toFixed(2))
                                : 0} */}
                              {data?.remaining !== undefined && data?.remaining !== null && data?.p_weight !== undefined && data?.pbox_unit !== undefined
                                ? `${convertQtyToKg(data.remaining, data.p_weight, data.pbox_unit)} kg`
                                : "0 kg"}
                            </span>
                          </td>
                          <td>
                            <span className="badge bg-danger bg-opacity-10 text-danger px-2.5 py-1.5 fw-bold" style={{ fontSize: "0.825rem", borderRadius: "6px" }}>
                              {/* {data?.reorder_point} */}
                              {data?.reorder_point !== undefined && data?.reorder_point !== null && data?.p_weight !== undefined && data?.pbox_unit !== undefined
                                ? `${convertQtyToKg(data.reorder_point, data.p_weight, data.pbox_unit)} kg`
                                : "0 kg"}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center text-muted py-5">
                          No stock alerts found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row d-none">
        <div className="col-12 col-lg-8">
          <div className="card radius-10">
            <div className="card-header">
              <div className="d-flex align-items-center">
                <div>
                  <h6 className="mb-0">Sales Overview</h6>
                </div>
                <div className="dropdown ms-auto">
                  <a
                    className="dropdown-toggle dropdown-toggle-nocaret"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    <i className="bx bx-dots-horizontal-rounded font-22 text-option" />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="javascript:;">
                        Action
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="javascript:;">
                        Another action
                      </a>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <a className="dropdown-item" href="javascript:;">
                        Something else here
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="chart-container-0">
                <canvas id="chart1" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-4">
          <div className="card radius-10">
            <div className="card-header">
              <div className="d-flex align-items-center">
                <div>
                  <h6 className="mb-0">Order Status</h6>
                </div>
                <div className="dropdown ms-auto">
                  <a
                    className="dropdown-toggle dropdown-toggle-nocaret"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    <i className="bx bx-dots-horizontal-rounded font-22 text-option" />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="javascript:;">
                        Action
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="javascript:;">
                        Another action
                      </a>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <a className="dropdown-item" href="javascript:;">
                        Something else here
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="chart-container-0">
                <canvas id="chart2" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row d-none">
        <div className="col-12 col-lg-8 col-xl-8">
          <div className="card radius-10">
            <div className="card-header bg-transparent">
              <div className="d-flex align-items-center">
                <div>
                  <h6 className="mb-0">Top Selling Country</h6>
                </div>
                <div className="dropdown ms-auto">
                  <a
                    className="dropdown-toggle dropdown-toggle-nocaret"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    <i className="bx bx-dots-horizontal-rounded font-22 text-option" />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="javascript:;">
                        Action
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="javascript:;">
                        Another action
                      </a>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <a className="dropdown-item" href="javascript:;">
                        Something else here
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div id="dashboard-map" style={{ height: 250 }} />
              <hr />
              <div className="mb-4">
                <div className="d-flex align-items-center gap-3">
                  <div className="country-icon">
                    <img
                      src="assets/images/county/01.png"
                      width={35}
                      alt=""
                    />
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-2">
                      United States <span className="float-end">50%</span>
                    </p>
                    <div className="progress" style={{ height: 5 }}>
                      <div
                        className="progress-bar bg-gradient-ibiza"
                        role="progressbar"
                        style={{ width: "50%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="d-flex align-items-center gap-3">
                  <div className="country-icon">
                    <img
                      src="assets/images/county/02.png"
                      width={35}
                      alt=""
                    />
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-2">
                      England <span className="float-end">65%</span>
                    </p>
                    <div className="progress" style={{ height: 5 }}>
                      <div
                        className="progress-bar bg-gradient-deepblue"
                        role="progressbar"
                        style={{ width: "65%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="d-flex align-items-center gap-3">
                  <div className="country-icon">
                    <img
                      src="assets/images/county/03.png"
                      width={35}
                      alt=""
                    />
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-2">
                      England <span className="float-end">75%</span>
                    </p>
                    <div className="progress" style={{ height: 5 }}>
                      <div
                        className="progress-bar bg-gradient-ohhappiness"
                        role="progressbar"
                        style={{ width: "75%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="d-flex align-items-center gap-3">
                  <div className="country-icon">
                    <img
                      src="assets/images/county/04.png"
                      width={35}
                      alt=""
                    />
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-2">
                      England <span className="float-end">85%</span>
                    </p>
                    <div className="progress" style={{ height: 5 }}>
                      <div
                        className="progress-bar bg-gradient-orange"
                        role="progressbar"
                        style={{ width: "85%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-0">
                <div className="d-flex align-items-center gap-3">
                  <div className="country-icon">
                    <img
                      src="assets/images/county/05.png"
                      width={35}
                      alt=""
                    />
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-2">
                      England <span className="float-end">95%</span>
                    </p>
                    <div className="progress" style={{ height: 5 }}>
                      <div
                        className="progress-bar bg-gradient-blues"
                        role="progressbar"
                        style={{ width: "95%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-4 col-xl-4">
          <div className="card radius-10 overflow-hidden">
            <div className="card-body">
              <div className="d-flex align-items-center mb-2">
                <div>
                  <p className="mb-0 text-secondary font-14">Page Views</p>
                  <h5 className="my-0">2050</h5>
                </div>
                <div className="ms-auto font-30">
                  <i className="bx bx-bookmark-alt" />
                </div>
              </div>
              <div className="chart-container-5">
                <canvas id="chart10" />
              </div>
            </div>
          </div>
          <div className="card radius-10 overflow-hidden">
            <div className="card-body">
              <div className="d-flex align-items-center mb-2">
                <div>
                  <p className="mb-0 text-secondary font-14">Bounce Rate</p>
                  <h5 className="my-0">24.5%</h5>
                </div>
                <div className="ms-auto font-30">
                  <i className="bx bx-line-chart" />
                </div>
              </div>
              <div className="chart-container-5">
                <canvas id="chart11" />
              </div>
            </div>
          </div>
          <div className="card radius-10 overflow-hidden">
            <div className="card-body">
              <div className="d-flex align-items-center mb-2">
                <div>
                  <p className="mb-0 text-secondary font-14">Total Cliks</p>
                  <h5 className="my-0">8945</h5>
                </div>
                <div className="ms-auto font-30">
                  <i className="bx bx-heart" />
                </div>
              </div>
              <div className="chart-container-5">
                <canvas id="chart12" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {documentModal && (
        <DocumentViewerModal
          setShowModal={setDocumentModal}
          documentUrl={DocumentUrl}
        />
      )}

      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  Update Document
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleCancel}
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3">
                    <label>Expiry Date</label>
                    <input
                      type="date"
                      name="expiry_date"
                      value={formData.expiry_date}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label>Upload New Document</label>
                    <input
                      type="file"
                      name="document"
                      accept=".csv, .xls, .xlsx, .doc, .docx, .pdf, .jpg, .png"
                      onChange={handleFileChange}
                      ref={fileInputRef} // Attach the ref here
                      className="form-control"
                      required={selectedDocumentTable ? false : true}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-success float-end"
                    disabled={!isFileSelected}
                  >
                    Update Document
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary float-end me-2"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
